import React from "react";
import MinedDiamondMarkup from "./MinedDiamondMarkup";
const LabGrowMarkup = () => {
  return <MinedDiamondMarkup type="LAB" />;
};
export default LabGrowMarkup;
